import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../../auth-context';
import { Link, NavLink } from 'react-router-dom';
import { Databases, Query } from 'appwrite';
import { FaChevronRight } from 'react-icons/fa';
import client from '../../app-user';
import { SidebarNavData } from './SidebarNavData';
import styles from './SidebarNav.module.css';

const databases = new Databases(client);
const DATABASE_ID = process.env.REACT_APP_DATABASE_ID || 'database';
const TEAMS_COLLECTION_ID = process.env.REACT_APP_TEAMS_COLLECTION_ID || 'teams';

const SidebarNav: React.FunctionComponent = () => {
  const { user } = useContext(AuthContext);
  const [expanded, setExpanded] = useState(false);
  const [showRfa, setShowRfa] = useState(true);
  const isAdmin = user.session?.labels.includes('admin');

  useEffect(() => {
    const loadStatus = async () => {
      if (!user.session?.id) return;
      try {
        const result = await databases.listDocuments(DATABASE_ID, TEAMS_COLLECTION_ID, [Query.limit(200)]);
        const team = result.documents.find((doc: any) => doc.UserAuthId === user.session?.id || doc.userAuthId === user.session?.id);
        const status = (team?.rfaPage || '').toLowerCase();
        setShowRfa(status !== 'disabled');
      } catch {
        setShowRfa(true);
      }
    };

    loadStatus();
  }, [user.session?.id]);

  const visibleItems = SidebarNavData.filter(
    item => (!item.adminOnly || isAdmin) && (item.path !== '/rfa' || showRfa)
  );

  return (
    <aside className={`${styles.sidebar} ${expanded ? styles.expanded : styles.collapsed}`}>
      <Link className={styles.brand} to="/" aria-label="Pocket Pigskin Association home">
        <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="Pocket Pigskin Association" />
      </Link>

      <button
        className={styles.toggle}
        type="button"
        onClick={() => setExpanded(current => !current)}
        aria-label={expanded ? 'Tuck in navigation menu' : 'Open navigation menu'}
        aria-expanded={expanded}
      >
        <FaChevronRight className={`${styles.toggleArrow} ${expanded ? styles.toggleArrowExpanded : ''}`} />
      </button>

      <nav className={styles.navigation} aria-label="Main navigation">
        <ul className={styles.menuList}>
          {visibleItems.map(item => (
            <li className={styles.menuItem} key={item.path}>
              <NavLink
                className={({ isActive }) => `${styles.menuLink} ${isActive ? styles.active : ''}`}
                to={item.path}
                title={expanded ? undefined : item.title}
              >
                <span className={styles.icon}>{item.icon}</span>
                <span className={styles.label}>{item.title}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default SidebarNav;
